import React, { Fragment, PureComponent } from 'react';
import { pagesApi } from '../../apis/PagesApi';
import IconNext from '../../assets/icons/IconNext';
import IconPrev from '../../assets/icons/IconPrev';
import PageEditor from '../../components_admin/Components/PageEditor/PageEditor';
import { localeFunction } from '../../locales/functions';

class AboutPages extends PureComponent {
   state = {
      page1: null,
      page2: null,
      pageList: [],
      currentPage: null,

      loading: true,
   }

   componentDidMount() {
      this.loadData();
   }

   loadData = async () => {
      const response = await pagesApi.getPageAbout();
      if (response && response.id) {
         let pageList = [];
         if (response.page1) {
            pageList.push('page1');
         }
         if (response.page2) {
            pageList.push('page2');
         }
         let currentPage = pageList.length !== 0 ? pageList[0] : null;
         this.setState({
            page1: response.page1 || null,
            page2: response.page2 || null,
            pageList,
            currentPage,
         });
      }
   }

   goNext = () => {
      this.setState({
         currentPage: 'page2',
      });
   }
   goPrev = () => {
      this.setState({
         currentPage: 'page1',
      });
   }

   render() {
      return (
         <div className="pages-list">
            <div className="pages-container">
               {
                  this.state.pageList.length !== 0 &&
                  this.state.pageList.map((pageName, idx) => {
                     let isCurrent = pageName === this.state.currentPage;
                     let status = !isCurrent ? (idx === 0 ? 'prevPage' : 'nextPage') : '';
                     return (
                        <Fragment key={pageName}>
                           <div className={`outline-box ${status} ${pageName} animate__animated
                              ${(isCurrent) ? (pageName === 'page1' ? 'animate__fadeInLeft' : 'animate__fadeInRight') :
                                 (pageName === 'page1' ? 'animate__fadeOutLeft' : 'animate__fadeOutRight')}`}
                           >
                              <PageEditor
                                 value={this.state[pageName]}
                                 readOnly
                              />
                           </div>
                           {
                              this.state.page2 && this.state.currentPage === 'page1' &&
                              <button className={`wrapped-btn ${!isCurrent ? 'hidden' : ''}`} onClick={this.goNext}>
                                 {
                                    this.props.isMobileView &&
                                    <span>{localeFunction.locale.next_page}</span>
                                 }
                                 <IconNext />
                              </button>
                           }
                           {
                              this.state.page1 && this.state.currentPage === 'page2' &&
                              <button className={`wrapped-btn prev ${!isCurrent ? 'hidden' : ''}`} onClick={this.goPrev}>
                                 <IconPrev />
                                 {
                                    this.props.isMobileView &&
                                    <span>{localeFunction.locale.back_page}</span>
                                 }
                              </button>
                           }
                        </Fragment>
                     )
                  })
               }
            </div>
         </div>
      );
   }
}

export default AboutPages;